import React from 'react';
import {css} from 'emotion';


const LayoutStep = (props) =>{
  return(
    <div className={css`box-sizing:border-box;padding:20px;width:100%;margin-top:20px;background-color:white;height:600px`}>
      {props.children}
    </div>
  )
}

export default LayoutStep
